import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41b1110a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=41b1110a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1110a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b1110a')) {
      api.createRecord('41b1110a', component.options)
    } else {
      api.reload('41b1110a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41b1110a&scoped=true&", function () {
      api.rerender('41b1110a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/SystemFieldForm/index.vue"
export default component.exports